const detailApi = {
  indexTopBanner: `/advertising/index/top/banners`, // 横幅
  bomSimple: '/bom/simple/V2', // 免费验证版
  asyncFavoriteAdd: '/async/favorite/add/dynamic', // 添加收藏
  asyncMemberDetailPerfect: '/async/member/detail/perfect',
  getMouseStock: '/get/mouse/stock', // 获取mouser价格数据
  asyncAddOverseasBrokage: '/async/add/overseas/brokage', // 添加海外代购商品
  compareProductAddV2: '/compare/product/add/V2', // 添加对比商品
  compareProductGetV2: '/compare/product/get/V2', // 获取对比商品
  compareProductRemoveV2: '/compare/product/remove/V2', // 移除对比商品
  compareProductRemoveAllV2: '/compare/product/removeAll/V2', // 移除全部对比商品
  compareProductCheckV2: '/compare/product/check/V2', // 移除全部对比商品
  cartAddNormal: '/cart/add/normal', // 加入购物车
  activityCoupon: '/v2/activity/coupon', // 获取优惠券
  getTiCoupon: '/get/ti/coupon', // ti获取优惠券
  asyncGroupValidatePerfect: '/async/group/validate/perfect', // 购买立推
  checkStatus: '/check/status', // 获取购买状态
  countByParamV2: '/countByParamV2', // 查看同类型数量
  insertProductConnection: '/insertProductConnectionV2',
  asyncSpecialProductDefault: '/async/special/product/default/warehouse',
  asyncSpecialAdd: '/async/special/add',
  asyncSecondKillValidatePerfect: '/async/second/kill/validate/perfect',
  isCouponUnavailableForBook: '/v2/is/coupon/unavailable/for/book',
  isCouponUnavailableForOversea: '/v2/is/coupon/unavailable/for/oversea',
  getTiCouponTag: '/get/ti/coupon/tag',
  activityOverseaCouponTips: '/activity/oversea/coupon/tips',
  asyncVailDateOverseaStock: '/async/validate/oversea/stock/v2',
  selectProductFavorite: '/select/product/favorite/v2',
  mroRecommend: '/mro/recommend',
  productRelationRecommend: '/product/relation/recommend',
  couponLabelShow: '/coupon/label/show',
  productPdfDesc: '/product/pdf/desc',
  productStockPriceSign: '/product/stock/price/sign', // 价格库存加密接口
  cidVerify: '/cid/verify', // 流控接口
};

export default detailApi;
